export default "__VITE_ASSET__CED_32A0__"